import heroBg from './hero.jpg';
import logo from './LOGO.png';
import runnerAbout from './oranglari.png';
import start from './oranglari2.jpg';
import ASimg1 from './DSC00331.jpg';
import ASimg2 from './RIF05923.jpg';
import ortu from './IMG_3601.jpg';
import c8k from './DSC09302.jpg';
import c16k from './DC05047.jpg';
import c32k from './DSC00002.jpg';
import c50k from './DSC01469.jpg';
import lake1 from './DSC00462.jpg';
import lake2 from './DSCF1704.jpg';
import lake3 from './DSC01416.jpg';
import routemap from './route-map.jpg'

export const ASSETS = {
  heroBg: heroBg,
  runnerAbout: runnerAbout,
  start: start,
  category8k: c8k,
  category16k: c16k,
  category32k: c32k,
  category50k: c50k,
  logo: logo,
  ASimg1 : ASimg1,
  ASimg2 : ASimg2,
  ortu : ortu,
  lake1 : lake1,
  lake2 : lake2,
  lake3 : lake3,
  routemap : routemap,
};